<template>
	<div>
		<b-navbar fixed="top" variant="white" class="shadow">
			<div class="container">
				<b-navbar-brand :to="{ name: 'components' }">
					<img
						:src="require('@/assets/img/logo.jpg')"
						alt="Mobil"
						class="img-fluid"
						style="height: auto; width: 100%; max-width: 150px"
					/>
				</b-navbar-brand>
			</div>
		</b-navbar>
		<div
			class="container mt-4 text-dark"
			style="padding-top: 80px; padding-bottom: 80px"
		>
			<h1 class="mb-4 text-dark">BASES DEL CONCURSO "LA GRAN CARRERA MOBIL"</h1>
			<p>
				<strong
					><span
						>CONCURSO DIGITAL BASADO EN CONOCIMIENTOS Y HABILIDAD Y/O
						DESTREZA.</span
					></strong
				>
			</p>
			<p>
				<strong><span>1. VIGENCIA DE LA PROMOCI&Oacute;N:</span></strong
				><span>&nbsp;</span>
			</p>
			<p>
				<span
					>Las compras que participan en el concurso ser&aacute;n exclusivamente
					las que se realicen&nbsp;</span
				><strong
					><span
						>del 20 de agosto del 2021 al 25 de octubre del 2021.</span
					></strong
				><strong><span>&nbsp;</span></strong>
			</p>
			<p>
				<span
					>Periodo permitido para participar y registro de tickets de compra
					ser&aacute;
					<strong
						>del 20 de agosto del 2021 al 25 octubre del 2021.</strong
					></span
				>
			</p>
			<p>
				<strong
					><span>2. CONDICI&Oacute;N DE PARTICIPACI&Oacute;N:</span></strong
				>
			</p>
			<p>
				<span>P</span
				><span
					>or cada ticket de compra por carga de combustible en cualquiera de
					los centros de &nbsp;servicio MOBIL participantes en</span
				><span
					>&nbsp;Rep&uacute;blica Mexicana dentro del periodo de vigencia de la
					din&aacute;mica,&nbsp;</span
				><span>registra tu ticket en&nbsp;</span
				><a href="http://www.mobilracing.mx"><span>www.mobilracing.mx</span></a
				><span>&nbsp;</span
				><span
					>y podr&aacute;s participar en el concurso MOBIL, para que con base en
					tus conocimientos o habilidades puedas ganar</span
				><span
					>&nbsp;1 (uno) de los
					<strong
						>10 pases Dobles en la zona Red Bull Racing del Grand Prix
						M&eacute;xico 2021</strong
					>
					<strong>&nbsp;de tres d&iacute;as&nbsp;</strong></span
				>
			</p>
			<p>
				<span
					>A los clientes que resulten acreedores se les entregar&aacute; uno de
					los siguientes incentivos:</span
				>
			</p>
			<p>
				<strong
					><span
						>PASE DOBLE EN LA ZONA RED BULL RACING DEL GRAND PRIX MEXICO 2021
						&nbsp;</span
					></strong
				>
			</p>
			<p>
				<strong><span>TOTAL DE PASES DOBLES: 10</span></strong>
			</p>
			<p>
				<strong
					><span
						>4. PROCESO DE INSCRIPCION Y REGISTRO DE TICKETS &nbsp;</span
					></strong
				>
			</p>
			<p>
				<span
					>Una vez que el cliente cumpla con la condici&oacute;n de
					participaci&oacute;n se&ntilde;alada, para llevar a cabo la
					mec&aacute;nica, ser&aacute; necesario lo siguiente:</span
				>
			</p>
			<ol start="1" style="list-style-type: lower-alpha">
				<li>
					<strong><span>Registro de Tickets:</span></strong
					><span
						>&nbsp;El cliente deber&aacute; registrar su ticket de compra dentro
						de la vigencia de la promoci&oacute;n, es decir,&nbsp;</span
					><span>Del 20 de agosto al 25 de octubre del 2021</span
					><span
						>, as&iacute; como subir una foto de su ticket de
						compra.&nbsp;</span
					>
				</li>
				<li>
					<strong
						><span
							>Los clientes del programa RETO MOBIL que ya cuenten con un
							perfil, tendr&aacute;n derecho a doble
							participaci&oacute;n.&nbsp;</span
						></strong
					>
				</li>
				<li>
					<strong><span>Registro de datos en la p&aacute;gina</span></strong
					><span
						>&nbsp;con los siguientes datos: Nombre completo, fecha de
						nacimiento, g&eacute;nero, correo electr&oacute;nico y/o
						tel&eacute;fono.&nbsp;</span
					>
				</li>
			</ol>
			<p>
				<span
					>Posteriormente deber&aacute; de registrar sus tickets de compra con
					los siguientes datos: *C&oacute;digo de Facturaci&oacute;n, *Monto y
					Fecha del Ticket de Compra (impreso o electr&oacute;nico).&nbsp;</span
				>
			</p>
			<p>
				<span
					>* En caso de que el sistema no haya registrado los datos, se
					deber&aacute; contactar a&nbsp;</span
				><a href="http://www.mobilracing.mx"><span>www.mobilracing.mx</span></a
				><span>,&nbsp;</span
				><a href="mailto:hola@imakinando.mx"><span>hola@imakinando.mx</span></a
				><span>&nbsp;o a los telefonos 5556884444 y 5591972000&nbsp;</span
				><span>incluyendo la informaci&oacute;n del problema.</span>
			</p>
			<p>
				<span
					>La falta de cualquiera de los datos antes se&ntilde;alados,
					impedir&aacute; concluir con el proceso de registro del cliente y/o de
					los tickets de compra y/o confirmaciones de compra y por tanto no se
					generar&aacute; el (los) folio (s) de participaci&oacute;n
					correspondientes.&nbsp;</span
				>
			</p>
			<p>
				<span
					>De igual manera se se&ntilde;ala que dicha informaci&oacute;n y datos
					que proporcione el participante, deber&aacute;n ser ciertos y veraces,
					de lo contrario, no es responsabilidad del organizador y/o responsable
					si la informaci&oacute;n es falsa.</span
				>
			</p>
			<p>
				<strong><span>5. CONCURSO</span></strong>
			</p>
			<p>
				<strong
					><span
						>a) &nbsp;Mec&aacute;nica para llevar a cabo el Concurso:</span
					></strong
				><span>&nbsp;</span>
			</p>
			<p>
				<span
					>Los datos de participantes registrados dentro de la vigencia
					participar&aacute;n en el&nbsp;</span
				><strong><span>concurso&nbsp;</span></strong
				><strong><span>&ldquo;LA GRAN CARRERA MOBIL&rdquo;</span></strong
				><span>&nbsp;</span
				><span
					>&nbsp;a celebrarse
					<strong>del 20 de agosto de 2021 al 25 de</strong></span
				><strong><span>&nbsp;de octubre del 2021&nbsp;</span></strong
				><span>a trav&eacute;s de la p&aacute;gina&nbsp;</span
				><a href="http://www.mobilracing.mx"><span>www.mobilracing.mx</span></a
				><span>&nbsp;</span
				><span
					>&nbsp;. El cliente, ya habiendo registrado su o sus tickets de compra
					de gasolina en los centros de servicio MOBIL participantes y una vez
					obtenido su o sus folios de participaci&oacute;n, puede comenzar a
					participar de las diversos retos que deber&aacute;n resolverse con
					base en sus conocimientos, destreza o habilidades. El concurso se
					compone de 2 fases: fase 1 PREGUNTA 1; PREGUNTA 2 Y PREGUNTA 3. Una
					vez habiendo resuelto las tres preguntas con respuestas correctas de
					opci&oacute;n m&uacute;ltiple, el sistema informar&aacute; del
					suguiente y &uacute;ltimo reto (FASE 2). Cada participante
					deber&aacute; resolver cada uno de estos retos y fases de forma
					correcta para ganar el derecho de participar en RETO de la FASE 2.
					<strong
						>As&iacute; s&oacute;lo los clientes que hayan resuelto
						favorablemenete LOS RETOS DE LAS 2 FASES</strong
					>, ser&aacute;n <strong>CANDIDATOS</strong> a ser los
					acreedores&nbsp;</span
				><span
					>de 1 (uno) de los
					<strong
						>10 Pases DOBLES en la Zona Red Bull Racing del Grand Prix
						M&eacute;xico 2021 los d&iacute;as 05, 06 y 07 de noviembre del
						2021&nbsp;</strong
					></span
				>
			</p>
			<p>
				<strong
					><span
						>LOS GANADORES DE LOS 10 PASES DOBLES, SER&Aacute;N LOS 10
						PARTICIPANTES QUE RESULTEN HABIENDO CONTESTANDO EL RETO DE LA FASE 2
						DE FORMA EXACTA O LOS QUE M&Aacute;S SE APROXIMEN A ESA
						CANTIDAD.</span
					></strong
				>
			</p>
			<p>
				<strong><span>6. &nbsp;</span></strong
				><strong><span>CRITERIOS DE DESEMPATE:</span></strong>
			</p>
			<p>
				<strong><span>a).- Primer criterio de desempate. -&nbsp;</span></strong
				><span
					>Ser&aacute; ganadores de los primeros 10 lugares, aquellos
					Participantes que hubieran calculado, con base en sus conocimientos,
					destreza y/o habilidades CALCULEN DE FORMA EXACTA el n&uacute;mero
					solicitado en el RETO 2. Ser&aacute; un s&oacute;lo listado de
					participaci&oacute;n general con los 10 ganadores (los primeros 10 que
					respondan correctamente).</span
				>
			</p>
			<p>
				<strong><span>b).- Segundo criterio de desempate.-&nbsp;</span></strong
				><span
					>En caso de mayor n&uacute;mero de empates, en la cantidad solicitada
					en el RETO 2, se considerar&aacute; como Segundo criterio de desempate
					la FECHA Y HORA que conste en el registro de participaci&oacute;n
					dentro del sitio web. Los 10 (diez) Participantes que adem&aacute;s de
					satisfacer el Primer Criterio se hubieran registrado con
					<strong
						>la fecha y hora m&aacute;s cercanos a la fecha de inicio de la
						Promoci&oacute;n</strong
					>
					ser&aacute;n ganadores.</span
				>
			</p>
			<p>
				<strong><span>c).- Tercer criterio de desempate.- &nbsp;</span></strong
				><span
					>En caso de empate, incluso en la fecha y hora en el registro, el
					criterio de desempate estar&aacute; en el MONTO DE COMPRA en gasolina
					en el ticket registrado.</span
				>
			</p>
			<p>
				<strong
					><span
						>Los criterios de desempate antes descritos se aplicar&aacute;n en
						el orden expuesto, conforme han sido listados, de manera
						sucesiva.</span
					></strong
				>
			</p>
		</div>
		<FooterBack></FooterBack>
	</div>
</template>
<script>
import FooterBack from "./components/FooterBack";
export default {
	name: "bases",
	components: {
		FooterBack,
	},
};
</script>
